import type { Meta, StoryObj } from "@storybook/react";

import { fakeGroupClassSeries } from "@/__mocks__/groupClassSeries";
import type { GroupClassSeriesCardProps } from "@/ui/components/groupClasses/series/GroupClassSeriesCard";
import GroupClassSeriesCard from "@/ui/components/groupClasses/series/GroupClassSeriesCard";
import { IllustrationName } from "@/ui/theme/icons/illustrations/groupClasses";

const example = fakeGroupClassSeries();

const StoryMeta: Meta<GroupClassSeriesCardProps> = {
  title: "Components/Group Classes/Series Card",
  component: GroupClassSeriesCard,
  argTypes: {
    description: { control: "text" },
    forWhom: { control: "text" },
    groupClassExternalId: { control: "text" },
    iconName: {
      control: "select",
      options: Object.values(IllustrationName),
    },
    isLoading: { control: "boolean" },
    isUserRegistered: { control: "boolean" },
    onSelect: { action: "selected" },
    recurrenceDisplayString: { control: "text" },
    title: { control: "text" },
  },
  args: {
    description: example.description,
    groupClassExternalId: example.groupClassExternalId,
    iconName: example.iconName.toLowerCase(),
    isUserRegistered: example.isUserRegistered,
    recurrenceDisplayString: `${example.frequency} Monday, 2 - 3pm`,
    title: example.title,
  },
};

type Story = StoryObj<GroupClassSeriesCardProps>;

const Primary: Story = {};

const Registered: Story = {
  args: { isUserRegistered: true },
};

const Loading: Story = {
  args: { isLoading: true },
};

export { Loading, Primary, Registered };
export default StoryMeta;
